/**
 * Custom Cursor Controller
 * Smooth-following dot + ring with hover states.
 * Auto-hides on touch devices.
 */
(function() {
  const cursor = document.getElementById('custom-cursor');
  if (!cursor) return;
  
  // Detect touch device
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (isTouch) {
    document.documentElement.classList.add('touch-device');
    return;
  }
  
  document.documentElement.classList.add('cursor-enabled');
  
  const dot = cursor.querySelector('.custom-cursor__dot');
  const ring = cursor.querySelector('.custom-cursor__ring');
  const image = cursor.querySelector('.custom-cursor__image');
  
  let mouseX = 0;
  let mouseY = 0;
  let dotX = 0;
  let dotY = 0;
  let ringX = 0;
  let ringY = 0;
  let isVisible = false;
  
  // Easing factors (0-1, higher = faster)
  const DOT_EASE = 0.35;
  const RING_EASE = 0.15;
  
  // Interactive elements
  const hoverSelectors = 'a, button, [role="button"], input, textarea, select, [data-cursor-hover]';
  
  function updatePosition(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    
    if (!isVisible) {
      isVisible = true;
      cursor.removeAttribute('data-hidden');
    }
  }
  
  function animate() {
    // Smooth follow for dot
    dotX += (mouseX - dotX) * DOT_EASE;
    dotY += (mouseY - dotY) * DOT_EASE;
    
    // Slower follow for ring
    ringX += (mouseX - ringX) * RING_EASE;
    ringY += (mouseY - ringY) * RING_EASE;
    
    if (dot) {
      dot.style.left = `${dotX}px`;
      dot.style.top = `${dotY}px`;
    }
    
    if (ring) {
      ring.style.left = `${ringX}px`;
      ring.style.top = `${ringY}px`;
    }
    
    if (image) {
      image.style.left = `${dotX}px`;
      image.style.top = `${dotY}px`;
    }
    
    requestAnimationFrame(animate);
  }
  
  function handleMouseEnter(e) {
    if (e.target.closest(hoverSelectors)) {
      cursor.classList.add('is-hovering');
    }
  }
  
  function handleMouseLeave(e) {
    if (e.target.closest(hoverSelectors)) {
      cursor.classList.remove('is-hovering');
    }
  }
  
  function handleMouseDown() {
    cursor.classList.add('is-clicking');
  }
  
  function handleMouseUp() {
    cursor.classList.remove('is-clicking');
  }
  
  function handleMouseLeaveWindow() {
    isVisible = false;
    cursor.setAttribute('data-hidden', 'true');
  }
  
  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // Bind events
  document.addEventListener('mousemove', updatePosition);
  document.addEventListener('mouseover', handleMouseEnter);
  document.addEventListener('mouseout', handleMouseLeave);
  document.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mouseup', handleMouseUp);
  document.addEventListener('mouseleave', handleMouseLeaveWindow);
  
  // Start animation loop (skip if reduced motion)
  if (!prefersReducedMotion) {
    animate();
  } else {
    // Instant positioning for reduced motion
    document.addEventListener('mousemove', function(e) {
      const x = e.clientX;
      const y = e.clientY;
      if (dot) { dot.style.left = `${x}px`; dot.style.top = `${y}px`; }
      if (ring) { ring.style.left = `${x}px`; ring.style.top = `${y}px`; }
      if (image) { image.style.left = `${x}px`; image.style.top = `${y}px`; }
    });
  }
  
  // Initially hidden until mouse moves
  cursor.setAttribute('data-hidden', 'true');
})();
